import { AvailableDeliveryMethodsDetail } from "../../interfaces/session/ShoppingCart";
import { DELIVERY_METHODS } from "./helper";

export function isPickUpDeliveryAvailable(availableDeliveryMethodsDetails: AvailableDeliveryMethodsDetail[]) {
  const pickUpAvailable = availableDeliveryMethodsDetails?.some((el) => el.deliveryMethod === DELIVERY_METHODS.PICKUP);
  const deliveryAvailable = availableDeliveryMethodsDetails?.some((el) => el.deliveryMethod === DELIVERY_METHODS.DELIVERY);
  const shipmentAvailable = availableDeliveryMethodsDetails?.some((el) => el.deliveryMethod === DELIVERY_METHODS.SHIPPING);
  return {
    pickUpAvailable, deliveryAvailable, shipmentAvailable,
  };
}
